import React from 'react';
import { steps, business } from '../mock';
import { Phone } from 'lucide-react';

const toneMap = {
  yellow: 'var(--pill-yellow)',
  green: 'var(--pill-green)',
  lilac: 'var(--pill-lilac)',
};

export default function HowItWorks() {
  return (
    <section id="how" className="section relative overflow-hidden">
      <div className="container-x relative" style={{ zIndex: 1 }}>
        <div className="text-center max-w-[680px] mx-auto reveal">
          <p className="eyebrow mb-2">How It Works</p>
          <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.1rem)' }}>Your care journey, made easy in 3 steps</h2>
          <p className="mt-5" style={{ color: 'var(--muted)' }}>
            Getting started is simple and pressure-free. Here&rsquo;s the path to thriving at home
            with a loving caregiver.
          </p>
        </div>

        <div className="relative mt-16">
          {/* Animated connecting line (desktop) */}
          <div className="hidden md:block absolute left-0 right-0" style={{ top: 84 }}>
            <svg width="100%" height="40" viewBox="0 0 1000 40" preserveAspectRatio="none" fill="none">
              <path
                d="M 170 20 Q 340 -14 500 20 Q 660 54 830 20"
                stroke="var(--sage)"
                strokeWidth="2.5"
                strokeDasharray="8 10"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="grid md:grid-cols-3 gap-10 lg:gap-6 relative">
            {steps.map((s, i) => {
              const Icon = s.icon;
              return (
                <div key={s.no} className="reveal text-center relative">
                  <div className="relative inline-flex mx-auto float-anim" style={{ animationDelay: `${i * 0.6}s` }}>
                    <span
                      className="flex items-center justify-center rounded-full transition-transform duration-300"
                      style={{ width: 168, height: 168, backgroundColor: toneMap[s.tone], boxShadow: '0 20px 44px -26px rgba(30,59,44,0.5)' }}
                    >
                      <Icon size={56} style={{ color: 'var(--forest)' }} strokeWidth={1.4} />
                    </span>
                    <span
                      className="absolute top-2 left-1/2 -translate-x-1/2 text-xs font-semibold px-3 py-1 rounded-full text-white"
                      style={{ backgroundColor: 'var(--forest)' }}
                    >
                      Step-{s.no}
                    </span>
                  </div>
                  <h3 className="text-xl mt-6">{s.title}</h3>
                  <p className="mt-3 max-w-[320px] mx-auto" style={{ color: 'var(--muted)' }}>{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="text-center mt-14">
          <a href={business.phoneHref} className="btn-sage">
            <Phone size={18} /> Call {business.phone}
          </a>
        </div>
      </div>
    </section>
  );
}
